export default "assets/images/icons/whatsapp-19b684fe.svg";